module.exports = __webpack_public_path__ + "static/media/qmac-construction-ltd.8862ccde.jpg";